import { render, staticRenderFns } from "./AscPageErrorTemplate.vue?vue&type=template&id=6b7702b9&"
import script from "./AscPageErrorTemplate.vue?vue&type=script&lang=js&"
export * from "./AscPageErrorTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AscPageErrorTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports